const dialog = {
    boxShadow: `0px 4px 10px 0px rgba(0, 0, 0, 0.20)`,
    borderRadius: '4px',
    '& .MuiPaper-root': {
        desktop: {
            width: `clamp(450px, 38%, 535px)`,
            '&:last-child': {
                marginRight: 2,
            },
        },
    },
};
const headerBox = {
    display: 'flex',
    justifyContent: 'space-around',
};
const title = {
    color: 'secondary.dark',
    lineHeight: '26px',
    fontSize: '1.125rem',
    fontWeight: 800,
    textAlign: 'center',
    padding: {
        mobile: '16px',
        desktop: '16px 24px',
    },
    justifyContent: 'center',
};
const titleDesktop = { fontWeight: 400, fontSize: '28px', textAlign: 'center', pb: 1 };
const desktopTitle = {
    ...title,
    fontSize: '28px',
    textAlign: 'center',
};
const contentWrapper = {
    pt: 0,
    pb: 4,
    display: 'flex',
    px: { desktop: '1.5rem', mobile: '1rem' },
    width: '100%',
    justifyContent: 'center',
};
const content = {
    color: 'secondary.dark',
    lineHeight: '24px',
    fontSize: '0.875rem',
    fontWeight: 400,
    width: '300px',
    whiteSpace: 'pre-line',
    textAlign: 'center',
};
const buttonContainer = {
    whiteSpace: 'nowrap',
    display: 'flex',
    width: '100%',
    justifyContent: 'center',
};
const mobileButtoncontainer = {
    ...buttonContainer,
    flexDirection: 'column',
    gap: 2,
};
const desktopButtonContainer = {
    gap: 2,
    ...buttonContainer,
};
export default {
    title,
    titleDesktop,
    content,
    dialog,
    desktopButtonContainer,
    mobileButtoncontainer,
    headerBox,
    desktopTitle,
    contentWrapper,
};
